Vendd.Scripts.load(function () {

    $('.x-control.x-article-reviews[data-type="reviews"]').each(function (i, wrapper) {

        var $wrapper = $(wrapper);

        var sortKey = '';

        var isAjax = $wrapper.data('ajax');
        var sessionIsAuthenticated = $wrapper.data('session-is-authenticated');

        if ($wrapper.find('> input[type="hidden"][data-member="isauthenticated"]').length > 0)
            sessionIsAuthenticated = $wrapper.find('> input[type="hidden"][data-member="isauthenticated"]').val() === 'true';

        var isReviewed = $wrapper.data('article-reviewed-by-current-user');
        if ($wrapper.find('> input[type="hidden"][data-member="isreviewed"]').length > 0)
            isReviewed = $wrapper.find('> input[type="hidden"][data-member="isreviewed"]').val() === 'true';

        var $orderByLtestLink = $('*[data-click="order-by-latest"]', $wrapper);
        var $orderByHelpfullnessLink = $('*[data-click="order-by-helpfullness"]', $wrapper);

        $orderByLtestLink.click(function (e) {
            if (isAjax) {
                if (!$orderByLtestLink.hasClass('x-selected')) {
                    $orderByHelpfullnessLink.removeClass('x-selected');
                    $orderByLtestLink.addClass('x-selected');

                    sortKey = 'latest';
                }
            } else {

                var url = document.location.href;
                if (document.location.search.indexOf('page=') > 0) {

                    url = LhApp.Function.Url.setParameterValueOnUrl(url, 'page', '1');
                }

                document.location = LhApp.Function.Url.setParameterValueOnUrl(url, 'sort-by', 'latest');
            }
        });

        $orderByHelpfullnessLink.click(function (e) {
            if (isAjax) {
                if (!$orderByHelpfullnessLink.hasClass('x-selected')) {
                    $orderByLtestLink.removeClass('x-selected');
                    $orderByHelpfullnessLink.addClass('x-selected');

                    sortKey = 'helpfullness';
                }
            } else {

                var url = document.location.href;
                if (document.location.search.indexOf('page=') > 0) {
                    url = LhApp.Function.Url.setParameterValueOnUrl(url, 'page', '1');
                }

                document.location = LhApp.Function.Url.setParameterValueOnUrl(url, 'sort-by', 'helpfullness');
            }
        });

        var $articleReviewForm = $('.x-control.x-form.x-article-review-form[data-control="form"]', $wrapper);
        if ($articleReviewForm.length == 1) {

            var $openFormLink = $('.form-show-hide[data-click="open-article-review-form"]', $wrapper);
            var $closeFormLink = $('.form-show-hide[data-click="close-article-review-form"]', $articleReviewForm);

            $openFormLink.click(function (e) {
                if ($openFormLink.hasClass('x-closed')) {
                    $openFormLink.removeClass('x-closed').addClass('x-opened');
                    $closeFormLink.removeClass('x-closed').addClass('x-opened');
                    $articleReviewForm.removeClass('x-collapsed').removeClass('x-closed').addClass('x-opened');
                    $articleReviewForm.show();
                }
            });

            $closeFormLink.click(function (e) {
                if ($closeFormLink.hasClass('x-opened')) {
                    $openFormLink.removeClass('x-opened').addClass('x-closed');
                    $closeFormLink.removeClass('x-opened').addClass('x-closed');
                    $articleReviewForm.removeClass('x-opened').addClass('x-closed');
                    $articleReviewForm.hide();
                }
            });

        };

        var $loginPopup = $('div[data-type="review-login-popup"]', $wrapper);
        if (!sessionIsAuthenticated) {

            if ($loginPopup.length == 0) throw "login popUp does not exist on article review box";

            var $showLoginMessageLink = $('*[data-click="show-login-message"]', $wrapper);
            $showLoginMessageLink.click(function (e) {
                $loginPopup.show();
            });

            var $loginLink = $('*[data-click="login"]', $loginPopup);
            var $registerLink = $('*[data-click="register"]', $loginPopup);
            var $closeBtn = $('*[data-click="close-popup"]', $loginPopup);

            var $loginWidget = $('.x-control.x-widget.x-login-widget[data-control="login"][data-type="widget"]').first();

            var redirectUrl = LhApp.Function.Url.setParameterValue('mode', 'add-review');

            $loginLink.click(function (e) {
                $loginPopup.hide();

                if ($loginWidget.length > 0 && $loginWidget.data('expandable') == true) {

                    var $loginForm = $('.x-login-form', $loginWidget);

                    $loginForm.data('redirect', redirectUrl);

                    $('html, body').animate({ scrollTop: $loginWidget.offset().top }, 1500);
                    LhApp.pauseScroll = true;
                    setTimeout(function () { LhApp.pauseScroll = false; }, 2000);
                    $loginWidget.get(0).expand();
                    e.stopPropagation();

                } else {
                    document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Login, 'ReturnUrl', encodeURIComponent(redirectUrl));
                };
            });

            $registerLink.click(function (e) {
                document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Register, 'ReturnUrl', encodeURIComponent(redirectUrl));
            });

            $closeBtn.click(function (e) {
                $loginPopup.hide();
            });

        } else {
            $loginPopup.remove();
        }

    });

});